"use client";

import { c as _c } from "react/compiler-runtime";
import { Link } from "@/components/LocaleLink";
import { ArrowLeft, HelpCircle, MessageCircle, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useTranslation } from "@/lib/hooks/useTranslation";
import { Logo } from "@/components/Logo";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { Footer } from "@/components/Footer";
export default function FAQPage() {
  const $ = _c(59);
  const {
    tObj,
    locale
  } = useTranslation();
  const t = tObj.landing;
  let t0;
  if ($[0] !== t.faq.q1.answer || $[1] !== t.faq.q1.question) {
    t0 = {
      question: t.faq.q1.question,
      answer: t.faq.q1.answer
    };
    $[0] = t.faq.q1.answer;
    $[1] = t.faq.q1.question;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t.faq.q2.answer || $[4] !== t.faq.q2.question) {
    t1 = {
      question: t.faq.q2.question,
      answer: t.faq.q2.answer
    };
    $[3] = t.faq.q2.answer;
    $[4] = t.faq.q2.question;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t.faq.q3.answer || $[7] !== t.faq.q3.question) {
    t2 = {
      question: t.faq.q3.question,
      answer: t.faq.q3.answer
    };
    $[6] = t.faq.q3.answer;
    $[7] = t.faq.q3.question;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t.faq.q4.answer || $[10] !== t.faq.q4.question) {
    t3 = {
      question: t.faq.q4.question,
      answer: t.faq.q4.answer
    };
    $[9] = t.faq.q4.answer;
    $[10] = t.faq.q4.question;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t.faq.q5.answer || $[13] !== t.faq.q5.question) {
    t4 = {
      question: t.faq.q5.question,
      answer: t.faq.q5.answer
    };
    $[12] = t.faq.q5.answer;
    $[13] = t.faq.q5.question;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t0 || $[16] !== t1 || $[17] !== t2 || $[18] !== t3 || $[19] !== t4) {
    t5 = [t0, t1, t2, t3, t4];
    $[15] = t0;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  const faqItems = t5;
  let t6;
  if ($[21] !== locale) {
    t6 = locale === "fr" ? [{
      question: "Comment cr\xE9er un compte ?",
      answer: "Clique sur 'Commencer gratuitement', entre ton email et un mot de passe. Tu recevras un email de confirmation pour activer ton compte."
    }, {
      question: "Combien d'entretiens puis-je faire ?",
      answer: "En version gratuite, tu as un quota de tokens qui te permet de faire plusieurs entretiens complets par mois. Le quota se renouvelle r\xE9guli\xE8rement."
    }, {
      question: "Comment fonctionne l'analyse ATS de CV ?",
      answer: "Upload ton CV, puis colle une offre d'emploi. Notre IA compare les deux et te donne un score de compatibilit\xE9, les mots-cl\xE9s manquants et des suggestions d'am\xE9lioration."
    }, {
      question: "Puis-je supprimer mes donn\xE9es ?",
      answer: "Oui, tu peux supprimer ton compte et toutes tes donn\xE9es \xE0 tout moment depuis les param\xE8tres de ton profil."
    }, {
      question: "L'IA remplace-t-elle un vrai entretien ?",
      answer: "Non, Velyq est un outil d'entra\xEEnement. Il te permet de t'exercer et de gagner en confiance, mais ne remplace pas la pratique avec de vraies personnes."
    }, {
      question: "Comment contacter le support ?",
      answer: "Tu peux nous contacter par email \xE0 contact@velyq.com ou rejoindre notre Discord pour obtenir de l'aide rapidement."
    }] : [{
      question: "How do I create an account?",
      answer: "Click 'Get started free', enter your email and password. You'll receive a confirmation email to activate your account."
    }, {
      question: "How many interviews can I do?",
      answer: "In the free version, you have a token quota that allows you to do several complete interviews per month. The quota renews regularly."
    }, {
      question: "How does ATS CV analysis work?",
      answer: "Upload your CV, then paste a job offer. Our AI compares both and gives you a compatibility score, missing keywords and improvement suggestions."
    }, {
      question: "Can I delete my data?",
      answer: "Yes, you can delete your account and all your data at any time from your profile settings."
    }, {
      question: "Does AI replace a real interview?",
      answer: "No, Velyq is a training tool. It allows you to practice and gain confidence, but doesn't replace practice with real people."
    }, {
      question: "How to contact support?",
      answer: "You can contact us by email at contact@velyq.com or join our Discord to get help quickly."
    }];
    $[21] = locale;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  const additionalFaqs = t6;
  let t7;
  if ($[23] !== additionalFaqs || $[24] !== faqItems) {
    t7 = [...faqItems, ...additionalFaqs];
    $[23] = additionalFaqs;
    $[24] = faqItems;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  const allFaqs = t7;
  let t8;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Link href="/"><Logo size="sm" /></Link>;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <LanguageSwitcher />;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ArrowLeft className="h-4 w-4 mr-2" />;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  const t11 = locale === "fr" ? "Retour" : "Back";
  let t12;
  if ($[29] !== t11) {
    t12 = <header className="border-b"><div className="container mx-auto px-4 py-4 flex items-center justify-between">{t8}<div className="flex items-center gap-2">{t9}<Link href="/"><Button variant="ghost" size="sm">{t10}{t11}</Button></Link></div></div></header>;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="mb-6 flex justify-center"><div className="rounded-full bg-primary/10 p-4"><HelpCircle className="h-8 w-8 text-primary" /></div></div>;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  const t14 = locale === "fr" ? "Questions fr\xE9quentes" : "Frequently Asked Questions";
  let t15;
  if ($[32] !== t14) {
    t15 = <h1 className="text-3xl font-bold sm:text-4xl md:text-5xl mb-4">{t14}</h1>;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const t16 = locale === "fr" ? "Trouve rapidement les r\xE9ponses \xE0 tes questions sur Velyq" : "Quickly find answers to your questions about Velyq";
  let t17;
  if ($[34] !== t16) {
    t17 = <p className="text-muted-foreground text-lg">{t16}</p>;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t15 || $[37] !== t17) {
    t18 = <section className="container mx-auto px-4 py-12 sm:py-16 text-center"><div className="mx-auto max-w-2xl">{t13}{t15}{t17}</div></section>;
    $[36] = t15;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== allFaqs) {
    t19 = <section className="container mx-auto px-4 pb-16 sm:pb-20"><div className="mx-auto max-w-3xl"><Accordion type="single" collapsible={true} className="w-full space-y-4">{allFaqs.map(_temp)}</Accordion></div></section>;
    $[39] = allFaqs;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  const t20 = locale === "fr" ? "Tu as encore des questions ?" : "Still have questions?";
  let t21;
  if ($[41] !== t20) {
    t21 = <h2 className="text-2xl font-bold mb-4">{t20}</h2>;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  const t22 = locale === "fr" ? "Notre \xE9quipe est l\xE0 pour t'aider. Contacte-nous par email ou rejoins notre Discord." : "Our team is here to help. Contact us by email or join our Discord.";
  let t23;
  if ($[43] !== t22) {
    t23 = <p className="text-muted-foreground mb-8 max-w-md mx-auto">{t22}</p>;
    $[43] = t22;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <a href="mailto:contact@velyq.com"><Button variant="outline" className="w-full sm:w-auto"><Mail className="h-4 w-4 mr-2" />contact@velyq.com</Button></a>;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <MessageCircle className="h-4 w-4 mr-2" />;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  const t26 = locale === "fr" ? "Rejoindre Discord" : "Join Discord";
  let t27;
  if ($[47] !== t26) {
    t27 = <div className="flex flex-col sm:flex-row gap-4 justify-center">{t24}<a href="https://discord.gg/hbevuxEKCq" target="_blank" rel="noopener noreferrer"><Button className="w-full sm:w-auto">{t25}{t26}</Button></a></div>;
    $[47] = t26;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== t21 || $[50] !== t23 || $[51] !== t27) {
    t28 = <section className="border-t bg-muted/30 py-12 sm:py-16"><div className="container mx-auto px-4 text-center">{t21}{t23}{t27}</div></section>;
    $[49] = t21;
    $[50] = t23;
    $[51] = t27;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Footer />;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] !== t12 || $[55] !== t18 || $[56] !== t19 || $[57] !== t28) {
    t30 = <div className="min-h-screen bg-background">{t12}{t18}{t19}{t28}{t29}</div>;
    $[54] = t12;
    $[55] = t18;
    $[56] = t19;
    $[57] = t28;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  return t30;
}
function _temp(faq, index) {
  return <AccordionItem key={index} value={`item-${index}`} className="border rounded-lg px-4 sm:px-6"><AccordionTrigger className="text-left text-sm sm:text-base font-medium py-4">{faq.question}</AccordionTrigger><AccordionContent className="text-muted-foreground text-sm sm:text-base pb-4">{faq.answer}</AccordionContent></AccordionItem>;
}